// extracted by mini-css-extract-plugin
module.exports = {"image_wrp":"_6c97079b1b--image_wrp--UUYro","shield":"_6c97079b1b--shield--rCDQ0"};